import * as types from './mutation_types'
import axios from 'axios'
import decode from 'jwt-decode'
import { ENTRYPOINT } from '../../../config/entrypoint'

export const login = ({ commit }, data) => {
  return new Promise(async (resolve, reject) => {
    commit(types.AUTH_REQUEST)
    try {
      const resp = await axios({ url: ENTRYPOINT + '/get-token', data, method: 'POST' })
      const token = resp.data.token
      const userInfo = decode(token)
      localStorage.removeItem('last_tds_tab')
      localStorage.setItem('token', token)
      localStorage.setItem('border_style', JSON.stringify({ borderWidth: '0.0625rem', borderColor: '#000' }))
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
      commit(types.AUTH_SUCCESS, { token, user: userInfo })
      commit(types.USER_ROLE, userInfo.roles)
      commit(types.USER_SOCIETE_ID, userInfo.societeId)
      commit(types.USER_ID, userInfo.id)
      commit(types.SET_FIRSTNAME, userInfo.prenom)
      commit(types.SET_NAME, userInfo.nom)
      commit(types.SET_SOCIETENOM, userInfo.societeNom)
      resolve(resp)
    } catch (err) {
      console.log('error =>', err)
      commit(types.AUTH_ERROR)
      localStorage.removeItem('token')
      reject(err.response.data.message)
    }
  })
}

export const logout = ({ commit }) => {
  return new Promise(async (resolve, reject) => {
    try {
      await axios({ url: ENTRYPOINT + '/api/logout', method: 'POST' })
      commit(types.LOGOUT)
      localStorage.clear()
      delete axios.defaults.headers.common['Authorization']
      resolve()
    } catch (err) {
      reject(err.response.data.data.error)
    }
  })
}

export const addClient = async ({ commit }, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/societes/ajout', data, method: 'POST' })
      resolve(resp)
    } catch (err) {
      reject(err.response.data.data.error)
    }
  })
}

export const getClient = async ({ commit }, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/societes/' + data, method: 'GET' })
      resolve(resp)
    } catch (err) {
      reject(err)
    }
  })
}

export const updateClient = async ({ commit }, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/societes/maj/' + data.id, data: data.formData, method: 'POST' })
      resolve(resp)
    } catch (err) {
      reject(err.response.data.data.error)
    }
  })
}

export const deleteClient = async ({ commit }, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/societes/supprime/' + data, method: 'DELETE' })
      resolve(resp)
    } catch (err) {
      console.log(err)
      reject(err.response)
    }
  })
}

export const getClients = ({ commit }, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/societes/liste?page=' + data, method: 'GET' })
      commit(types.SOCIETE_LISTES, resp.data.data.items)
      resolve(resp.data.data)
    } catch (err) {
      reject(err.response.statusText)
    }
  })
}

export const getUsersByClientId = ({ commit }, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/utilisateurs/liste/' + data, method: 'GET' })
      resolve(resp.data.data.items)
    } catch (err) {
      reject(err.response.data.data.error)
    }
  })
}

export const createUser = ({ commit }, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/utilisateur/ajout', data, method: 'POST' })
      resolve(resp)
    } catch (err) {
      reject(err.response.data.data.error)
    }
  })
}
export const getUser = ({ commit }, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/utilisateurs/' + data, method: 'GET' })
      resolve(resp.data.data)
    } catch (err) {
      reject(err)
    }
  })
}

export const updateUser = ({ commit }, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/utilisateurs/maj/' + data.id, data: data.users, method: 'POST' })
      resolve(resp)
    } catch (err) {
      reject(err.response.data.message)
    }
  })
}

export const deleteUser = async ({ commit }, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/utilisateurs/supprime/' + data, method: 'DELETE' })
      resolve(resp)
    } catch (err) {
      reject(err.response.data.data.error)
    }
  })
}

export const confirmationUser = ({ commit }, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/utilisateurs/inscription-confirmation', data, method: 'POST' })
      resolve(resp.data.data)
    } catch (err) {
      reject(err.response.data.message)
    }
  })
}

export const addAdminClient = ({ commit }, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/clients/ajout', data, method: 'POST' })
      resolve(resp.data.data)
    } catch (err) {
      reject(err.response.data.message)
    }
  })
}

export const listAdminClient = ({ commit }, { data, page }) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/clients/liste/' + data, data: { page }, method: 'GET' })
      resolve(resp.data.data)
    } catch (err) {
      reject(err.response.data.message)
    }
  })
}

export const deleteAdminClient = async ({ commit }, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/clients/supprime/' + data, method: 'DELETE' })
      resolve(resp)
    } catch (err) {
      reject(err.response.data.data.error)
    }
  })
}

export const activeLicence = async ({ commit }, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/licence-societe/active/' + data, method: 'POST' })
      resolve(resp)
    } catch (err) {
      reject(err.response.data.data.error)
    }
  })
}

export const deactiveLicence = async ({ commit }, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/licence-societe/desactive/' + data, method: 'POST' })
      resolve(resp)
    } catch (err) {
      reject(err.response.data.data.error)
    }
  })
}

export const getAdminClient = ({ commit }, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/clients/' + data, method: 'GET' })
      resolve(resp.data.data)
    } catch (err) {
      reject(err.response.data.message)
    }
  })
}

export const updateAdminClient = ({ commit }, { id, data }) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/clients/maj/' + id, data, method: 'POST' })
      resolve(resp)
    } catch (err) {
      reject(err.response.data.data.error)
    }
  })
}

export const resetPassword = async ({ commit }, data) => {
  try {
    const res = await axios({ url: ENTRYPOINT + '/utilisateurs/recuperation-mot-de-passe', data, method: 'POST' })
    return res.status
  } catch (err) {
    return err.response.data.message
  }
}

export const recuperationPassword = ({ commit }, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/utilisateurs/modification-mot-de-passe', data, method: 'POST' })
      resolve(resp.data.data)
    } catch (err) {
      reject(err.response.data.message)
    }
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/login/actions.js